window.clipContent = function(wrapper, content, text) {
	const contentWrapper = document.querySelectorAll(`.${wrapper}`);

	contentWrapper.forEach((elem) => {
		const otherContent = elem.querySelector(`.${content}`);
		const shrinkElement = elem.querySelector('.shrink');
		const textContent = elem.querySelector(`.${text}`);
		const unshrinkElements = elem.querySelectorAll('.unshrink');

		const elemStyle = window.getComputedStyle(elem);
		const textContentStyle = window.getComputedStyle(textContent);

		let unshrinkHeight = Array.from(unshrinkElements).reduce((total, unshrinkElem) =>
			total + unshrinkElem.offsetHeight, 0);
		const wrapperHeight = parseInt(elemStyle.height, 10);
		const otherContentHeight = otherContent.offsetHeight;
		const verticalPadding = parseInt(textContentStyle.paddingTop, 10) + parseInt(textContentStyle.paddingBottom, 10);
		const maxHeight = wrapperHeight - otherContentHeight - verticalPadding;

		if (elem.offsetHeight > maxHeight) {
			const lineHeight = 26;
			let numberOfStrokes = Math.floor((maxHeight - unshrinkHeight - 24) / lineHeight);

			shrinkElement.style.cssText += `
							display: -webkit-box;
							height: ${numberOfStrokes * lineHeight}px;
							-webkit-line-clamp: ${numberOfStrokes};
							-webkit-box-orient: vertical;
							overflow-y: hidden;
							text-overflow: ellipsis;
					`;
		}
	});
};
